// src/components/sidebar/sidebarConfig.ts
import { type INavigationRoute } from './NavigationRoutes'

export type UserRole = 'admin' | 'super_admin' | 'agent' | 'support'

export interface RoleConfig {
  mode: 'blacklist' | 'whitelist'
  hiddenRoutes: string[]        // Pour blacklist (agent)
  hiddenChildren: string[]      // Pour blacklist (agent)
  allowedRoutes: string[]       // Pour whitelist (support) - noms exacts des routes
  allowedChildren: string[]     // Pour whitelist (support)
  routeMappings: Record<string, string>
}

// Routes cachées par rôle (mode blacklist - pour agent)
const HIDDEN_ROUTES: Record<string, string[]> = {
  agent: [
    'announcements', 'vip-rights', 'landing-management', 'domain',
    'versions-section', 'videos', 'posts', 'users_tab', 'country',
    'steal_stat', 'chat-section', 'chat-conversations', 'content-section',
    'config', 'translate', 'game-section', 'exchange', 'price-config',
    'orders', 'landing', 'wallet-management', 'admin-agent-withdraw'
  ]
}

// Enfants cachés par rôle (mode blacklist - pour agent)
const HIDDEN_CHILDREN: Record<string, string[]> = {
  agent: [
    'announcements', 'annonce-editor', 'annonce-editor_dark', 'landing-management', 'promotion-platform',
    'promotions', 'vip-rights', 'agents-vip', 'vip', 'users', 'price-config',
    'versions', 'versions-link', 'videos', 'category', 'chat-log', 'tag',
    'post', 'category_p', 'tag_p', 'emoji', 'banner', 'ads', 'mangas',
    'country', 'config', 'translate', 'game-section', 'exchange',
    'users-vip', 'landing-page', 'landing', 'admin-agent-withdraw'
  ]
}

// Routes AUTORISÉES pour support (whitelist - noms EXACTS dans NavigationRoutes)
// IMPORTANT: Mettez ici les noms EXACTS de vos routes comme définis dans NavigationRoutes
export const SUPPORT_ALLOWED_ROUTES = [
  'content-section',
  'chat-section',
  'chat-conversations',
]

// Enfants AUTORISÉS pour support (whitelist)
export const SUPPORT_ALLOWED_CHILDREN = [
  'chat-section',
  'chat-conversations',
]

// Mapping des routes par rôle
const ROUTE_MAPPINGS: Record<string, Record<string, string>> = {
  agent: {
    withdraw: 'agent-withdraw',
    'wallet-management': 'agent-wallet-management',
    'agents-management': 'agent-agents-management',
    promotions: 'agent-promotions',
    'landing-page': 'agent-landing-page',
    'promotion-platform': 'agent-promotion-platform',
    'promotion-tracking': 'agent-promotion-tracking',
    purchase_history: 'agent-purchase_history',
    statistique: 'agent-statistique',
    'vip-rights': 'agent-vip-rights',
    'vip-setting': 'agent-vip-setting',
    'agents-vip': 'agent-agents-vip',
    vip: 'agent-vip',
    'users-vip': 'agent-users-vip',
    announcements: 'agent-announcements',
  },
  support: {}
}

export const getRoleConfig = (role: UserRole): RoleConfig => {
  const isAdmin = role === 'admin' || role === 'super_admin'
  const isSupport = role === 'support'
  
  if (isAdmin) {
    return {
      mode: 'blacklist',
      hiddenRoutes: [],
      hiddenChildren: [],
      allowedRoutes: [],
      allowedChildren: [],
      routeMappings: {
        'agent-agents-incomes': 'agents-incomes'
      }
    }
  }

  if (isSupport) {
    return {
      mode: 'whitelist',
      hiddenRoutes: [],
      hiddenChildren: [],
      allowedRoutes: SUPPORT_ALLOWED_ROUTES,
      allowedChildren: SUPPORT_ALLOWED_CHILDREN,
      routeMappings: ROUTE_MAPPINGS[role] || {}
    }
  }

  // Agent (blacklist)
  return {
    mode: 'blacklist',
    hiddenRoutes: HIDDEN_ROUTES[role] || [],
    hiddenChildren: HIDDEN_CHILDREN[role] || [],
    allowedRoutes: [],
    allowedChildren: [],
    routeMappings: ROUTE_MAPPINGS[role] || {}
  }
}
